/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  /**
   * 
   */
  const bundleSubscriptionProducts = {
    isChecking: false,
    BUNDLED_SUBSCRIPTIONS: {
       // Physical product variant ID (extract from div#whatmoreVariantId of the single product page): Subscription product variant ID
      42499133931579: 42469217534011,
      42746920337467: 42469217534011,
      // Shakti Safety Necklace - Rose Gold - Special Discount
      43014909165627: 42469217534011,
      // Shakti Safety Necklace – Murin Dark Blue - Special Discount
       43014916505659: 42469217534011,
      // Shakti Safety Necklace – Blue - Special Discount
      43014913949755: 42469217534011,
      // Maitri Safety Bracelet – Gold - Special Discount
      43014916505659: 42469217534011,
      // Shakti Safety Necklace – Silver - Special Discount
      43014914310203: 42469217534011,
      // Maitri Safety Bracelet – Murin Dark Blue - Special Discount
      43014916407355: 42469217534011,
      // Maitri Safety Bracelet – Silver - Special Discount
      43014916079675: 42469217534011,
      // Maitri Safety Bracelet – Blue - Special Discount
      43014915981371: 42469217534011,
      // Maitri Safety Bracelet – Rose Gold - Special Discount
      43014915522619: 42469217534011,
      // Shakti Safety Necklace – Gold - Special Discount
      43014915293243: 42469217534011
    },
    SUBSCRIPTION_SELLING_PLAN: {
      42469217534011: 2319286331
    },
    
    // --- Core Logic Functions ---
    updateShopPayButtonVisibility: function(selectedVariantId) {
      const isExcluded = this.BUNDLED_SUBSCRIPTIONS[parseInt(selectedVariantId)] !== undefined;
      document
        .querySelectorAll('.shopify-payment-button')
        .forEach(function(buyBtn) {
          if (isExcluded) {
            buyBtn.style.display = 'none';
          } else {
            buyBtn.style.display = '';
          }
        });
    },
    watchVariationChanged: function() {
      // Find your product form element
      const productForm = document.querySelector('product-form, #product-form'); 

      if (productForm) {
        // Listen for Shopify's custom event that fires after a variant is selected
        productForm.addEventListener('shopify:variant:change', (event) => {
          const newVariantId = event.detail.variant.id;
          this.updateShopPayButtonVisibility(newVariantId);
        });

        setTimeout(() => {
          // Run on initial load to set the correct state
          const initialVariantId = document.querySelector('input[name="id"]').value;
          this.updateShopPayButtonVisibility(parseInt(initialVariantId));
        }, 500);
      }
    },
    /**
     * Intercepts cart updates (e.g., changes to quantity or removal) so that we will either add subscription products or we prevent removal of subscription products
     * that are still needed based on the physical products in the cart.
     * @param {Object} update - An object containing variant ID : new quantity pairs being applied to the cart.
     * @returns {boolean} - Returns true if the cart was modified, false otherwise.
     */
    onCartUpdate: async function (update) {
      this.isChecking = true;
      try {
        // Key list of the product ids that we want to check
        const physicalProductIds = Object.keys(this.BUNDLED_SUBSCRIPTIONS);

        // Emulate adding the updates to the cart
        const response = await fetch('/cart.js');
        const cart = await response.json();
        // Update quantities based on the proposed updates where the updates[x].id is the items[x].key
        var updatedCart = { ...cart };
        if (update != undefined) {
          updatedCart.items = updatedCart.items.map(item => {
            if (update.id == item.key) {
              return {
                ...item,
                quantity: parseFloat(update.quantity)
              };
            }
            return item;
          });
        }

        const getMatchingPhyicalProductId = (item) => {
          var physicalProductId = physicalProductIds.find(id => id == item.variant_id);
          if (physicalProductId != undefined) {
            return parseInt(physicalProductId);
          }
          return null;
        };
        const getMatchingSubscriptionForProduct = (physicalProductId) => {
          physicalProductId = parseInt(physicalProductId);
          return this.BUNDLED_SUBSCRIPTIONS[physicalProductId];
        };

        var minQuanityRequiredBySubscriptionProductId = {};
        updatedCart.items.forEach(item => {
          physicalProductId = getMatchingPhyicalProductId(item);
          if (physicalProductId != null) {
            const subscriptionProductId = getMatchingSubscriptionForProduct(physicalProductId);
            if (minQuanityRequiredBySubscriptionProductId[subscriptionProductId] == undefined) {
              minQuanityRequiredBySubscriptionProductId[subscriptionProductId] = 0;
            }
            minQuanityRequiredBySubscriptionProductId[subscriptionProductId] += item.quantity;
          }
        });

        // Now check which subscription products need to be added or updated
        var qtyPerSubscriptionProductToUpdate = {};
        var qtyPerSubscriptionProductToAdd = {};
        Object.keys(minQuanityRequiredBySubscriptionProductId).forEach(subscriptionProductId => {
          const minQty = minQuanityRequiredBySubscriptionProductId[subscriptionProductId];
          const currentQty = updatedCart.items.filter(item => item.variant_id == subscriptionProductId).map(item => item.quantity).reduce((a, b) => a + b, 0);
          if (currentQty == 0 && minQty > 0) {
            qtyPerSubscriptionProductToAdd[subscriptionProductId] = minQty;
          } else if (minQty > currentQty) {
            qtyPerSubscriptionProductToUpdate[subscriptionProductId] = minQty;
          }
        });

        if (Object.keys(qtyPerSubscriptionProductToAdd).length == 0 && Object.keys(qtyPerSubscriptionProductToUpdate).length == 0) {
          return false;
        }

        // First add any new subscription products needed
        for (const [subscriptionProductId, minSubscriptionQty] of Object.entries(qtyPerSubscriptionProductToAdd)) {
          const selling_plan = this.SUBSCRIPTION_SELLING_PLAN[subscriptionProductId];
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                "Accept": "application/json",
              },
              body: JSON.stringify({
                id: parseInt(subscriptionProductId),
                quantity: parseInt(minSubscriptionQty),
                selling_plan
              })
            })
              .then(response => {
                if (!response.ok) {
                  return response.json().then(err => {
                    console.error('Error details:', err);
                    throw err;
                  });
                }
                return response.json();
              });
          } catch (error) {
            console.error('Error:', error);
          }
        }

        // Next update any existing subscription products needed
        for (const [subscriptionProductId, minSubscriptionQty] of Object.entries(qtyPerSubscriptionProductToUpdate)) {
          try {
            var updates = {};
            updates[parseInt(subscriptionProductId)] = minSubscriptionQty;
            const response = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ updates, sections: "cart-items,cart-icon-bubble,cart-live-region-text,cart-footer" })
            });
          } catch (error) {
            console.error('Error:', error);
          }
        }

        return true;
      } finally {
        this.isChecking = false;
      }
    },

    // --- Utility Functions ---
    currentPageLoadedWatchdog: function() {
      const self = this;
      // Example: Check if we are on the cart page and do something
      if (window.location.pathname.includes('/cart')) {
        if (self.onCartUpdate(undefined)) {
          // location.reload();
        }
      }
    },

    fetchWatchdog: function() {
      const originalFetch = window.fetch;
      const self = this;

      window.fetch = async function(...args) {
        const response = await originalFetch.apply(this, args);

        if ( !self.isChecking ) {
          if (
              args[0].includes('/cart/change') 
              ||
              args[0].includes('/cart/add')
              ||
              args[0].includes('/cart/update')
          )
          {
            await self.onCartUpdate(undefined);
          }
        }

        return response;
      };
    },

    // --- Initialization and Event Handling ---

    /**
     * Initializes the subscription bundling logic by attaching event listeners.
     */
    init: function () {
      // Use 'this' to refer to the object's methods and properties
      const self = this;
      self.fetchWatchdog();
      self.currentPageLoadedWatchdog();
      self.watchVariationChanged();
    }
  };

  // Start the logic
  bundleSubscriptionProducts.init();
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
